import script from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=1908be60&lang=scss"

const __exports__ = script;

export default __exports__